import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Col, Card, Container } from "reactstrap";
import { TopCenter, directiontoaster } from "../../Constant";
import { toast } from "react-toastify";
import ModalLink from "../Modal/Modal";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { FaRegFilePdf, FaRegSave, FaRegEdit } from "react-icons/fa";
import { Breadcrumbs, Btn } from "../../AbstractElements";
import "./styles.css";
import ModalDelete from "../ModalDelete/Modal";

const ViewNewsProvider = () => {
	const API_BASE_URL = window.appConfig.API_BASE_URL;
	const [data, setData] = useState([]);
	const [error, setError] = useState({ error: false, message: "" });
	const [pageLoaded, setPageLoaded] = useState(false);

	const fetchProviders = () => {
		const source = axios.CancelToken.source();
		const authToken = sessionStorage.getItem("token");

		const providers = axios
			.get(`${API_BASE_URL}/NewsProvider`, {
				headers: {
					Authorization: `Bearer ${authToken}`,
				},
				cancelToken: source.token,
			})
			.then((res) => {
				setData(res.data);
				setPageLoaded(true);
			})
			.catch((err) => {
				console.error(err);
			});
	};

	useEffect(() => {
		fetchProviders();
	}, []);

	const countynametemplate = (rowData) => {
		return rowData.country ? rowData.country.countryName : "";
	};

	const directiontoaster = (toastname) => {
		switch (toastname) {
			case "directionssuccessToast":
				toast.success("The provider was successfully deleted", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
			case "directionsdangerToast":
				toast.error("There was an error deleting the provider", {
					position: toast.POSITION.TOP_CENTER,
					autoClose: 1500,
				});
				break;
		}
	};

	const deleteHandler = async (providerId) => {
		try {
			const response = await axios.delete(
				`${API_BASE_URL}/NewsProvider/NewsProvider/${providerId}`
			);
			fetchProviders();
			directiontoaster("directionssuccessToast");
		} catch (error) {
			console.error("Something went wrong", error);
			directiontoaster("directionsdangerToast");
		}
	};

	function actionColumnBodyTemplate(newsProvider) {
		return (
			<>
				<Link to={`/EditNewsProvider/:${newsProvider.newsProviderId}`}>
					<i className="candidate-icons" title="Edit News Provider">
						<FaRegEdit />
					</i>
				</Link>
				<ModalDelete
					onDelete={() => deleteHandler(newsProvider.newsProviderId)}
					deleteMessage={`Are you sure you would like to delete ${newsProvider.name}`}
				/>
			</>
		);
	}

	return (
		<Fragment>
			<Breadcrumbs
				parent="News Feeds"
				title="Provider"
				mainTitle="News Provider"
			/>
			<Container fluid={true}>
				<Col>
					<Card>
						<DataTable
							scrollable
							rowHover
							rowClassName={"mustHaveRow"}
							value={data}
							size={"small"}
							paginator
							rows={25}
							rowsPerPageOptions={[10, 25, 50, 100]}
							filterDisplay={"row"}
							id="badge-table"
						>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="Name"
								field="name"
							></Column>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="URL"
								field="url"
							></Column>
							<Column
								filterHeaderClassName="p-inputtext-sm"
								showFilterMenu={false}
								filter={true}
								header="Country"
								body={countynametemplate}
							></Column>
							<Column
								className="candidate-icon-list"
								body={actionColumnBodyTemplate}
								header=""
							></Column>
						</DataTable>
						<Link to={`${process.env.PUBLIC_URL}/AddNewsProvider`}>
							<Btn attrBtn={{ color: "primary", id: "category-btn" }}>
								Add Provider
							</Btn>
						</Link>
					</Card>
				</Col>
			</Container>
		</Fragment>
	);
};

export default ViewNewsProvider;
